import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IRecordIdentifierSchemaResponse, TIdentifierRecordType } from './types';

/**
 * Every identifier key the brand can set on a record of this type, grouped by the instance
 * that declares it.
 *
 * One call rather than one per installed instance: the Integrations tab has to know about
 * every instance before it can decide whether to appear at all.
 *
 * An empty list means no installed addon declares a key for this record type, which is how
 * the tab knows to stay hidden.
 */
export const getRecordIdentifierSchema = async (
  recordType: TIdentifierRecordType,
): Promise<IRecordIdentifierSchemaResponse> => {
  const url = `${API_URL}/extensions/records/${recordType}/identifier-schema`;
  try {
    const res = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
    if (!res.ok) throw new Error(res.statusText);
    return await res.json();
  } catch (e) {
    throw new Error('Could not fetch the integrations schema', { cause: e });
  }
};
